import { Injectable } from '@angular/core';
import {CanLoad, Route, Router} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth/auth.service';

@Injectable()
export class AuthGuard implements CanLoad {
  constructor(
    private _router: Router,
    private _auth: AuthService
  ) {
    
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    if (this._auth.isAuthenticate()) {
      return true
    }else{
      /* var actualRoute = window.location.origin+'/auth/login';
      window.location.replace(actualRoute); */
      this._router.navigateByUrl("/auth/login")
    }
  }
}
